import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Router, Route, Redirect } from "react-router-dom";
import "antd/dist/antd.css";
import "./custom.css";
import history from "../history";

import Dashboard from "./Dashboard";
import Login from "./essential/Login";

//Contact
import Contact from "./Contact";
import Sponsor from "./Contact/Sponsor";
import Supplier from "./Contact/Supplier";
import SupplierReport from "./Contact/SupplierReport";
import ContactOptions from "./Contact/Options/index";
import InterOfficeAccounts from "./Contact/InterOfficeaccounts";

//product
import Attribute from "./Product/Attribute/index";
import Tag from "./Product/Tag/index";
import Category from "./Product/Category";
import AddProduct from "./Product/AddProduct";
import ProductDetails from "./Product/ProductDetails";
import LiveProductDetails from "./Product/ProductDetails/liveproducts";
import SeoProductDetails from "./Product/ProductDetails/SeoIndex";
import ViewProduct from "./Product/ProductDetails/ViewProduct";
import ViewOnlyProduct from "./Product/ProductDetails/ViewOnlyProduct";
import ProductImport from "./Product/Options/index";
import ProductVariationsQuickView from "./Product/ProductDetails/ProductVariationsQuickView";
import ProductVariationsEdit from "./Product/ProductDetails/ProductVariationsEdit";
import Images from "./Product/ProductDetails/productimage"
import InventoryMovement from "./Product/InventoryMovement";


//Stock

import Stock from "./Stock/Stock";
import AlertStock from "./Stock/AlertStock";
import Transfer from "./Transfer";
import TransferHistory from "./Transfer/TransferHistory";
import TransferStock from "./Stock/TransferStock/";
import StockValuation from "./Stock/StockValuationUpdated";
import Packaging from "./Stock/Packaging/";
import Material from "./Stock/Material/";
import Stockhistory from "./Stock/Userlog";

// Report
import salesReport from "./Report/Sales/salesReport";
import DeliveryReport from "./Report/Delivery/DeliveryReport";
import serviceReport from "./Report/Service/serviceReport";
import CurrentStock from "./Report/CurrentStock";
import PurchaseReport from "./Report/Purchase";
import vatReport from "./Report/VAT/salesReport";
import ExcelSalesReport from "./Report/ExcelSalesReport/salesReport";
import DueCollection from "./Report/DueCollection";
import PettyCashReport from "./Report/PettyCash/PettyCashReport";
import SoldProduct from "./Report/SoldProduct";
import SalesAccounting from "./Report/SalesAccounting/SalesAccounting";
import SalesDue from "./Report/Salesdue/salesReport";
import SalesPerson from "./Report/SalesPerson/index";
import Userlog from "./Report/Userlog";
import importlog from "./Report/Userlog/import";
import RefundReport from "./Report/RefundReport";
import DiscountReport from "./Report/DiscountReport";
import CashRegisterByPerson from "./Report/CashRegisterByPerson";

//purchase
import Purchase from "./Purchase";
import AddPurchaseOrder from "./Purchase/add";

//Sponsorship
import Wordrobe from "./Wordrobe";
import AddWordrobeOrder from "./Wordrobe/add";
import WordrobeStock from "./Wordrobe/Stock";
import WordrobeReceivedStock from "./Wordrobe/ReceivedStock";

//Order
import Order from "./Order";
import neworder from "./Order/newindex";
import AddOrder from "./Order/add";
import CustomerAddOrder from "./Order/neworder/add";
import Customerprofile from "./Order/neworder";
import Cupon from "./Cupon";
import OrderReport from "./Order/Report/salesReport";
import Showinvoice from "./Order/Showinvoice";
import Services from "./Services/Services";
import Invoice from "./Order/CustomerInvoice";
import Refund from "./Refund";

// Tools
import Tools from "./Tools";
import Warehouse from "./Warehouse";
import Outlet from "./Outlet";
import Office from "./Office";
import BusinessProfile from "./Settings/BusinessProfile/Index";
import ContactGroup from "./Settings/ContactGroup/Index";
import DeliveryGroup from "./Settings/DeliveryGroup/Index";
import AccountGroup from "./Settings/AccountGroup/Index";
import Permissions from "./Settings/Permissions";

// HRM
import Department from "./HRM/Department";
import userRole from "./HRM/UserRoles";
import Employee from "./HRM/Employee";
import LeaveType from "./HRM/LeaveType";
import EmployeeLeave from "./HRM/EmployeeLeave";
import EmployeeAttendance from "./HRM/Attendence";
import EmployeeAttendanceReport from "./HRM/AttendenceReport";
import EmployeeSalary from "./HRM/Salary";
import LoanManagement from "./HRM/LoanManagement";
import PaySlip from "./HRM/Payslip";
import PaySlipOld from "./HRM/PayslipOld";
import AttendanceImport from "./HRM/Attendence/AttendanceExcelimport";
import EmployeeSalaryList from "./HRM/SalaryReport";
import AttendanceReportShort from "./HRM/AttendanceReportShort";
import PettyCashImport from "./PettyCash/Excelimport";
import AttendanceReportShortbySalary from "./HRM/AttendanceReportShortbySalary";
import HRMSettings from "./HRM/HRMSettings";

// Accounting
import BranchSales from "./Accounting/BranchSales";
import Chartofaccounts from "./Accounting/Chartofaccounts";
import Accounts from "./Accounting/Accounts";
import AccountsStatusnew from "./Accounting/Ledger/AccountsStatusfast";
import AccountsStatus from "./Accounting/Ledger/AccountsStatusOld";
import Journals from "./Accounting/Journals";
import JournalVoucher from "./Accounting/JournalVoucher/";
import JournalVoucherCreate from "./Accounting/JournalVoucher/CreateNewChart";
import ReveiveVoucher from "./Accounting/ReveiveVoucher";
import ReveiveVoucherCreate from "./Accounting/ReveiveVoucher/CreateNewChart";
import PaymentVoucher from "./Accounting/PaymentVoucher";
import PaymentVoucherCreate from "./Accounting/PaymentVoucher/CreateNewChart";
import ContraVoucher from "./Accounting/ContraVoucher/";
import ContraVoucherCreate from "./Accounting/ContraVoucher/CreateNewChart";
import TrailBalance from "./Accounting/TrailBalanceUpdated";
import TrailBalanceManual from "./Accounting/TrailBalance";
import TrailBalanceAdvance from "./Accounting/TrailBalanceUpdated/advance"
import Ledger from "./Accounting/Ledger";
import CashAndBankBookLedger from "./Accounting/Ledger/CashAndBankLedger";
import PayableAndReceivable from "./Accounting/Ledger/PayableAndReceivable";
import ExpenseReport from "./Accounting/Ledger/ExpenseReport";
// import IncomeStatement from "./Accounting/IncomeStatement";
import IncomeStatement from "./Accounting/IncomeStatementUpdated";
// import BalanceSheet from "./Accounting/BalanceSheet";
import BalanceSheet from "./Accounting/BalanceSheetUpdated";
import CashReceiveReport from "./Accounting/Ledger/CashReceiveReport";
// import IncomeAndExpense from "./Accounting/Ledger/IncomeAndExpense";
//petty cash
import PettyCash from "./PettyCash";
import Closing from "./Accounting/Closing";

//Ecommerce
import EcommerceImage from "./Ecommerce/Images";
import Pages from "./Ecommerce/Pages";
import CampaignPages from "./Ecommerce/CampaignPages";
import MenuIndex from "./Ecommerce/Menu";

class App extends Component {
  constructor(props) {
    super(props);
    if (
      !this.props.auth.isSignedIn &&
      history.location.pathname.split("/", 3)[1] != "invoice"
    ) {
      history.push("/login");
    }
  }
  render() {
    return (
      <>
        <Helmet>
          {/* <title>ERP</title> */}
          <title>Anzara</title>
          {/* <title>Azran</title> */}
          {/* <title>Elor</title> */}
          {/* <title>Anzara HQ</title> */}

        </Helmet>

        <Router history={history}>
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/dashboard" component={Dashboard} />

          <Route exact path="/customer" component={Contact} />
          <Route exact path="/supplier" component={Supplier} />
          <Route exact path="/sponsor" component={Sponsor} />
          <Route exact path="/supplierreport" component={SupplierReport} />
          <Route exact path="/interofficeaccounts" component={InterOfficeAccounts} />
          <Route exact path="/contact/options" component={ContactOptions} />

          <Route exact path="/ecommerceimage" component={EcommerceImage} />
          <Route exact path="/pages" component={Pages} />
          <Route exact path="/campaignpages" component={CampaignPages} />
          <Route exact path="/menu" component={MenuIndex} />


          <Route exact path="/product" component={ProductDetails} />
          <Route exact path="/liveproduct" component={LiveProductDetails} />
          <Route exact path="/seoproduct" component={SeoProductDetails} />
          <Route exact path="/productimage" component={Images} />
          <Route exact path="/product/image/:id" component={ViewProduct} />
          <Route exact path="/product/images/:id" component={ViewOnlyProduct} />
          <Route exact path="/product/variation/:id" component={ProductVariationsQuickView} />
          <Route exact path="/product/variationedit/:id" component={ProductVariationsEdit} />


          <Route exact path="/product/Add" component={AddProduct} />
          <Route exact path="/product/attribute" component={Attribute} />
          <Route exact path="/product/tag" component={Tag} />
          <Route exact path="/product/category" component={Category} />
          <Route exact path="/product/import" component={ProductImport} />
          <Route exact path="/product/inventory-movement" component={InventoryMovement} />

          <Route exact path="/stock" component={Stock} />
          <Route exact path="/stock/inventory-movement" component={InventoryMovement} />

          <Route exact path="/stock/packaging" component={Packaging} />
          <Route exact path="/stock/material" component={Material} />
          <Route exact path="/stock/alert" component={AlertStock} />
          <Route exact path="/stock/transfer" component={Transfer} />
          <Route
            exact
            path="/stock/transfer/history"
            component={TransferHistory}
          />
          <Route exact path="/stock/TransferStock" component={TransferStock} />
          <Route exact path="/stock/history" component={Stockhistory} />

          <Route exact path="/Purchase" component={Purchase} />
          <Route exact path="/Purchase/Add" component={AddPurchaseOrder} />

          <Route exact path="/order" component={Order} />
          <Route exact path="/allorder" component={neworder} />
          <Route exact path="/order/Add" component={AddOrder} />
          <Route exact path="/order/Add/:id" component={CustomerAddOrder} />
          <Route
            exact
            path="/order/customerprofile"
            component={Customerprofile}
          />
          <Route
            exact
            path="/refund"
            component={Refund}
          />
          <Route exact path="/order/report" component={OrderReport} />
          <Route exact path="/service" component={Services} />
          <Route exact path="/cupons" component={Cupon} />
          <Route exact path="/invoice/:id" component={Invoice} />

          <Route exact path="/wordrobe" component={Wordrobe} />
          <Route exact path="/wordrobe/Add" component={AddWordrobeOrder} />
          <Route exact path="/wordrobe/stock" component={WordrobeStock} />
          <Route exact path="/wordrobe/received-stock" component={WordrobeReceivedStock} />

          {/* <Route exact path="/report/sales" component={salesReport} /> */}

          <Route exact path="/report/sales" component={SalesAccounting} />
          <Route exact path="/report/salesperson" component={SalesPerson} />
          <Route exact path="/report/salesdue" component={SalesDue} />
          <Route exact path="/report/discount" component={DiscountReport} />
          <Route exact path="/report/duecollection" component={DueCollection} />
          <Route exact path="/report/delivery" component={DeliveryReport} />
          <Route exact path="/report/service" component={serviceReport} />
          <Route exact path="/report/currentstock" component={CurrentStock} />
          <Route exact path="/report/alert" component={AlertStock} />
          <Route exact path="/report/sponsorship" component={AlertStock} />
          <Route exact path="/report/WordrobeStock" component={WordrobeStock} />
          <Route exact path="/report/purchase" component={PurchaseReport} />
          <Route exact path="/report/vat" component={vatReport} />
          <Route
            exact
            path="/report/excelsalesreport"
            component={ExcelSalesReport}
          />
          <Route exact path="/report/StockValuation" component={StockValuation} />
          <Route
            exact
            path="/report/PettyCashReport"
            component={PettyCashReport}
          />

          <Route exact path="/report/soldporductreport" component={SoldProduct} />
          <Route exact path="/report/userlog" component={Userlog} />
          <Route exact path="/report/importlog" component={importlog} />
          <Route exact path="/report/refund" component={RefundReport} />
          <Route exact path="/report/cashregister" component={CashRegisterByPerson} />


          <Route exact path="/tools" component={Tools} />
          <Route exact path="/office" component={Office} />
          <Route exact path="/warehouse" component={Warehouse} />
          <Route exact path="/outlet" component={Outlet} />
          <Route exact path="/businessprofile" component={BusinessProfile} />
          <Route exact path="/contactgroup" component={ContactGroup} />
          <Route exact path="/deliverygroup" component={DeliveryGroup} />
          <Route exact path="/accountgroup" component={AccountGroup} />
          <Route exact path="/pettycash" component={PettyCash} />
          <Route exact path="/permissions" component={Permissions} />

          <Route
            exact
            path="/accounting/chartofaccounts"
            component={Chartofaccounts}
          />
          <Route exact path="/accounting/accounts" component={Accounts} />
          <Route
            exact
            path="/accounting/accountstatusnew"
            component={AccountsStatus}
          />

          <Route
            exact
            path="/accounting/accountstatus"
            component={AccountsStatusnew}
          />

          <Route exact path="/accounting/branchsales" component={BranchSales} />
          <Route exact path="/accounting/journals" component={Journals} />
          <Route
            exact
            path="/accounting/journalvoucher"
            component={JournalVoucher}
          />
          <Route
            exact
            path="/accounting/journalvoucher/create"
            component={JournalVoucherCreate}
          />
          <Route
            exact
            path="/accounting/receivevoucher"
            component={ReveiveVoucher}
          />
          <Route
            exact
            path="/accounting/receivevoucher/create"
            component={ReveiveVoucherCreate}
          />
          <Route
            exact
            path="/accounting/paymentvoucher"
            component={PaymentVoucher}
          />
          <Route
            exact
            path="/accounting/paymentvoucher/create"
            component={PaymentVoucherCreate}
          />
          <Route
            exact
            path="/accounting/contravoucher"
            component={ContraVoucher}
          />
          <Route
            exact
            path="/accounting/contravoucher/create"
            component={ContraVoucherCreate}
          />
          <Route
            exact
            path="/accounting/trailbalance"
            component={TrailBalance}
          />

          <Route
            exact
            path="/accounting/trailbalancemanual"
            component={TrailBalanceManual}
          />
          <Route
            exact
            path="/accounting/trailbalanceadvance"
            component={TrailBalanceAdvance}
          />
          <Route exact path="/accounting/ledger" component={Ledger} />
          <Route
            exact
            path="/accounting/CashBankBook"
            component={CashAndBankBookLedger}
          />
          <Route
            exact
            path="/accounting/expensereport"
            component={ExpenseReport}
          />
          <Route
            exact
            path="/accounting/PayableAndReceivable"
            component={PayableAndReceivable}
          />
          <Route
            exact
            path="/accounting/cashreceivereport"
            component={CashReceiveReport}
          />
          {/* <Route
          exact
          path="/accounting/IncomeAndExpense"
          component={IncomeAndExpense}
        /> */}

          <Route exact path="/accounting/closing" component={Closing} />

          <Route
            exact
            path="/accounting/incomestatement"
            component={IncomeStatement}
          />
          <Route exact path="/accounting/balancesheet" component={BalanceSheet} />

          <Route exact path="/department" component={Department} />
          <Route exact path="/user-role" component={userRole} />
          <Route exact path="/employee" component={Employee} />
          <Route exact path="/leave-type" component={LeaveType} />
          <Route exact path="/employee-leave" component={EmployeeLeave} />
          <Route exact path="/attendance" component={EmployeeAttendance} />
          <Route
            exact
            path="/attendance-report"
            component={EmployeeAttendanceReport}
          />
          <Route exact path="/salary" component={EmployeeSalary} />
          <Route exact path="/loan-management" component={LoanManagement} />
          <Route exact path="/pay-slip" component={PaySlip} />
          <Route exact path="/pay-slip-old" component={PaySlipOld} />
          <Route exact path="/import-attendance" component={AttendanceImport} />
          <Route exact path="/import-petty-cash" component={PettyCashImport} />
          <Route exact path="/salary-report" component={EmployeeSalaryList} />
          <Route
            exact
            path="/attendance-report-short"
            component={AttendanceReportShort}
          />
          <Route
            exact
            path="/attendance-report-short-by-salary"
            component={AttendanceReportShortbySalary}
          />
          <Route exact path="/hrm-settings" component={HRMSettings} />
          
        </Router>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(App);
